// @flow

export default {
  apiKey: 'AIzaSyB2HyGwvIZ0bAX6I8WYRk5lRV3FBnkle_c',
  authDomain: 'plustimer.firebaseapp.com',
  databaseURL: 'https://plustimer.firebaseio.com',
  projectId: 'project-7421630029255993947',
  storageBucket: 'project-7421630029255993947.appspot.com',
  messagingSenderId: '965127717123'
};



// WEBPACK FOOTER //
// ./utils/firebaseConfig.js